import { PageLoadError } from '@components/page-load-error';
import {
  getAccountsQueryOptions,
  getProductsQueryOptions,
  getTransferSetsQueryOptions,
} from '@features/accounts/api';
import { getProfileQueryOptions } from '@features/user/api/get-profile';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import HighYieldSavingsLayout from 'src/routes/_authenticated/dashboard/-layouts/high-yield-savings-layout';

export const Route = createFileRoute(
  '/_authenticated/dashboard/high-yield-savings',
)({
  component: HighYieldSavingsLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='High-Yield Savings' error={error} />
  ),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(getAccountsQueryOptions),
      context.queryClient.ensureQueryData(getProductsQueryOptions),
      context.queryClient.ensureQueryData(getTransferSetsQueryOptions),
      context.queryClient.ensureQueryData(getProfileQueryOptions),
    ]);

    return null;
  },
  onEnter: () => window.scrollTo(0, 0),
});
